"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _components = require("@folio/stripes/components");
var _ResponsiveButtonGroup = _interopRequireDefault(require("../../../styles/ResponsiveButtonGroup.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// FIXME we should probably store the shared styles in a more aptly named file

/*
 * ComboButton component, can either act as Primary/Bonus buttons in a dropdown
 * OR it can act as a popover rendered besides a button.
 * If neither are provided it will act as an ordinary button
 */const ComboButton = _ref => {
  let {
    children,
    dropdownButtons = [],
    // These MUST be buttons
    dropdownProps = {},
    dropdownRender,
    marginBottom0,
    // Will ONLY control the margin of the dropdown/main button
    popoverProps = {},
    triggerProps,
    ...buttonProps
  } = _ref;
  const [open, setOpen] = (0, _react.useState)(false);
  const onToggle = (0, _react.useCallback)(() => setOpen(!open), [open, setOpen]);

  // FIXME a lot of this is shared with ResponsiveButtonGroup
  const styledDropdownButtons = (0, _react.useMemo)(() => dropdownButtons?.map(button => {
    return /*#__PURE__*/(0, _react.cloneElement)(button, {
      buttonStyle: 'dropdownItem'
    });
  }), [dropdownButtons]);

  // eslint-disable-next-line react/prop-types
  const renderActionMenuContent = (0, _react.useCallback)(() => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.DropdownMenu, {
    children: [...styledDropdownButtons]
  }), [styledDropdownButtons]);
  const renderTrigger = (0, _react.useCallback)(_ref2 => {
    let {
      onToggle: toggleFunc,
      triggerRef,
      keyHandler,
      open: openState,
      ariaProps,
      getTriggerProps
    } = _ref2;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      ref: triggerRef,
      "aria-label": "menu",
      buttonClass: (0, _classnames.default)(_ResponsiveButtonGroup.default.width100, _ResponsiveButtonGroup.default.dropdownButtonClass, {
        [`${_ResponsiveButtonGroup.default.marginBottom}`]: !marginBottom0
      }, {
        [`${_ResponsiveButtonGroup.default.marginBottom0}`]: marginBottom0
      }),
      buttonStyle: buttonProps?.buttonStyle ?? 'default',
      onClick: toggleFunc,
      onKeyDown: keyHandler,
      type: "button",
      ...getTriggerProps(),
      ...ariaProps,
      ...triggerProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Icon, {
        icon: openState ? 'triangle-up' : 'triangle-down',
        iconPosition: "end"
      })
    });
  }, [buttonProps?.buttonStyle, triggerProps, marginBottom0]);
  let comboTrigger;
  if (dropdownButtons.length > 0) {
    comboTrigger = /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dropdown, {
      className: _ResponsiveButtonGroup.default.dropdownClass,
      onToggle: onToggle,
      open: open,
      renderMenu: renderActionMenuContent,
      renderTrigger: renderTriggerProps => renderTrigger(renderTriggerProps),
      ...dropdownProps
    }, "combobutton-dropdown-toggle");
  } else if (dropdownRender) {
    comboTrigger = /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Popover, {
      onToggle: onToggle,
      open: open,
      renderTrigger: _ref3 => {
        let {
          open: openState,
          ref,
          toggle
        } = _ref3;
        return renderTrigger({
          getTriggerProps: () => {},
          onToggle: toggle,
          open: openState,
          triggerRef: ref
        });
      },
      ...popoverProps,
      children: dropdownRender
    });
  }
  if (comboTrigger) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)(_ResponsiveButtonGroup.default.buttonGroup),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        marginBottom0: marginBottom0,
        ...buttonProps,
        children: children
      }), comboTrigger]
    });
  }

  // Fallback, acts as a normal button
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    marginBottom0: marginBottom0,
    ...buttonProps,
    children: children
  });
};
ComboButton.propTypes = {
  children: _propTypes.default.node,
  dropdownButtons: _propTypes.default.arrayOf(_propTypes.default.node),
  dropdownProps: _propTypes.default.object,
  dropdownRender: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node]),
  id: _propTypes.default.string,
  marginBottom0: _propTypes.default.bool,
  popoverProps: _propTypes.default.object,
  triggerProps: _propTypes.default.object
};
var _default = exports.default = ComboButton;